import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  if (testimonials.length === 0) return null;
  return <Section tone="tint" eyebrow="Opinie" title="Co mówią osoby, które z niego korzystają" width="narrow" data-id="element-260" data-mp="3fycoti6qzx8o">
      <ul className="mx-auto max-w-4xl divide-y divide-blue-200/70" data-id="element-261" data-mp="3b01g5as6vss1">
        {testimonials.map(item => <li key={item.author} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-262" data-mp="370ajwrjw8kg4">
            <div className="flex items-start gap-3" data-id="element-263" data-mp="2x1uquj1b313z">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white" data-id="element-264" data-mp="2x2mmftuwkyu9">
                {item.initials}
              </span>
              <span data-id="element-265" data-mp="v7c6z7kfb7px">
                <span className="flex gap-0.5" aria-label="5 na 5 gwiazdek" data-id="element-266" data-mp="qalibvujz3sw">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-267" data-mp="h55aw37q1xxm" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-extrabold tracking-tight text-slate-900" data-id="element-268" data-mp="7a4yh1yghvp0">
                  {item.author}
                </span>
                <span className="block text-sm text-blue-900/70" data-id="element-269" data-mp="zxh9qfz62h30">{item.role}</span>
                {item.city && <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-270" data-mp="14uzm6gce7efr">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-271" data-mp="q5uy4iix2fzq" />
                    {item.city}
                  </span>}
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-slate-900 md:text-xl" data-id="element-272" data-mp="1iu8yv61e3qez">
              „{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}